"use client";

import React, { useState } from "react";
import { fallback_image, getValidImageUrl } from "@/utils/imageUtils";
import { Box, Card, Chip, Typography } from "@mui/material";
import { Star } from "@mui/icons-material";
import Image from "next/image";
import Link from "next/link";

export default function CategoryArticleCard({ article, height, categorySlug }) {
  const [imgSrc, setImgSrc] = useState(
    getValidImageUrl(article.image) || fallback_image,
  );

  const handleImageError = () => {
    setImgSrc(fallback_image);
  };

  return (
    <Link href={`/blog/${categorySlug}/${article.slug}`} passHref>
      <Card
        sx={{
          borderRadius: "1.5rem",
          overflow: "hidden",
          backgroundColor: "background.default",
          position: "relative",
          width: "100%",
          height,
          cursor: "pointer",
          transition: "transform 0.3s ease-in-out",
          "&:hover": {
            transform: "scale(1.05)",
            zIndex: 10,
          },
        }}
      >
        <Image
          src={imgSrc}
          alt={article.title}
          fill
          sizes="(max-width: 768px) 100vw, 350px"
          style={{ objectFit: "cover" }}
          onError={handleImageError}
        />

        {/* Featured Badge */}
        {article.featured && (
          <Chip
            icon={
              <Star sx={{ color: "#FFD700 !important", fontSize: "1rem" }} />
            }
            label="Featured"
            size="small"
            sx={{
              position: "absolute",
              top: "0.75rem",
              left: "0.75rem",
              backgroundColor: "rgba(0, 0, 0, 0.75)",
              color: "#FFD700",
              fontWeight: "bold",
              fontSize: "0.75rem",
              "& .MuiChip-icon": {
                marginLeft: "4px",
              },
            }}
          />
        )}

        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            color: "text.primary",
            padding: "0.5rem",
            textAlign: "center",
            backgroundColor: "background.accent",
          }}
        >
          <Typography sx={{ fontSize: "1.1rem", fontWeight: "bold" }}>
            {article.title}
          </Typography>
        </Box>
      </Card>
    </Link>
  );
}
